import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-batch",
  "use": "icon-batch-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-batch\"><defs><style type=\"text/css\"></style></defs><path d=\"M602.352941 120.470588h361.411765a60.235294 60.235294 0 0 1 0 120.470588H602.352941a60.235294 60.235294 0 0 1 0-120.470588zM191.668706 163.147294l127.789176-127.789176a120.470588 120.470588 0 0 1 170.345412 0L234.255059 290.906353a60.235294 60.235294 0 0 1-85.172706 0L0 141.854118a120.470588 120.470588 0 0 1 170.375529 0l21.293177 21.323294zM60.235294 903.529412h903.529412a60.235294 60.235294 0 0 1 0 120.470588H60.235294a60.235294 60.235294 0 0 1 0-120.470588z m0-391.529412h903.529412a60.235294 60.235294 0 0 1 0 120.470588H60.235294a60.235294 60.235294 0 0 1 0-120.470588z\" p-id=\"3249\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/batch.svg
// module id = C0FN
// module chunks = 7